import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
const loginHelpStateConfig = {
  url: 'login_help',
  views: {
    'loginHelp@authentication': {
      template: '<login-help-modal is-open="true" on-close="close()"></login-help-modal>',
      controller: ($state: ng.ui.IStateService, $scope: ng.IScope) => {
        $scope.close = () => {
          $state.go('^');
        };
      }
    }
  },
  data: {
    viewTitle: 'Login Help'
  }
};
class AuthenticationStateConfiguration {
  constructor(private $stateProvider: ng.ui.IStateProvider) {}
  state(stateConfiguration: any) {
    stateConfiguration = stateConfiguration || {};

    this.$stateProvider
      .state(
        'authentication',
        _4.merge(
          {
            url: '/authentication/',
            templateUrl: 'capability-ng-authentication/src/views/authentication/authentication.html',
            controller: 'AuthenticationController as $ctrl',
            data: {
              viewTitle: 'Authentication'
            },
            resolve: {
              config: (loginConfigurationCommand: ICommand) => loginConfigurationCommand()
            }
          },
          stateConfiguration['authentication']
        )
      )
      .state(
        'authentication.form',
        _4.merge(
          {
            url: 'form/',
            templateUrl: 'capability-ng-authentication/src/views/type_form/type_form.html',
            controller: 'loginFormController as $ctrl',
            data: {
              viewTitle: 'Authentication Form'
            },
            onEnter: (resetAccountCommand: ICommand) => {
              resetAccountCommand();
            }
          },
          stateConfiguration['authentication.form']
        )
      )
      .state(
        'authentication.remote',
        _4.merge(
          {
            url: 'remote/',
            templateUrl: 'capability-ng-authentication/src/views/type_remote/type_remote.html',
            controller: 'loginRemoteController as $ctrl',
            data: {
              viewTitle: 'Authentication Remote'
            }
          },
          stateConfiguration['authentication.remote']
        )
      )
      .state('authentication.form.login_help', { ...loginHelpStateConfig })
      .state('authentication.remote.login_help', { ...loginHelpStateConfig })
      .state(
        'authentication.form.failure',
        _4.merge(
          {
            url: 'failure/:explicitErrorReason/',
            templateUrl: 'capability-ng-authentication/src/views/form_failure/form_failure.html',
            controller: 'FormFailureController as $ctrl',
            data: {
              viewTitle: 'Authentication Failure',
              defaultErrorMessage: `You have entered an invalid User ID and/or Password. Please try again.`
            }
          },
          stateConfiguration['authentication.form.failure']
        )
      )
      .state(
        'authentication.remote.failure',
        _4.merge(
          {
            url: 'failure/?eaberror',
            templateUrl: 'capability-ng-authentication/src/views/form_failure/form_failure.html',
            controller: 'FormFailureController as $ctrl',
            data: {
              viewTitle: 'Authentication Failure',
              defaultErrorMessage: `Unable to log you in. Please try again.`
            }
          },
          stateConfiguration['authentication.remote.failure']
        )
      )
      .state(
        'support',
        _4.merge(
          {
            url: '/oops/:adviceLocation/',
            template: '<support-page></support-page>',
            data: {
              viewTitle: 'Oops'
            }
          },
          stateConfiguration['support']
        )
      );
  }

  myState(stateConfiguration: any) {
    this.$stateProvider.state(
      'my',
      _4.merge(
        {
          url: '/my/',
          abstract: true,
          resolve: {
            _Account: (loadAccountCommand: ICommand) => loadAccountCommand()
          }
        },
        stateConfiguration
      )
    );
  }
  public $get = () => ({});
}
angular
  .module('capability-ng-authentication')
  .provider('authenticationStateConfiguration', AuthenticationStateConfiguration);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-authentication/src/config/state_configuration.ts